/* @jsx h */
import { defineComponent, h, type PropType } from "vue";
import type { GridColumnDef } from "../types";

export const BooleanViewer = defineComponent({
  name: "BooleanViewer",
  props: {
    column: { type: Object as PropType<GridColumnDef>, required: true },
    value: { type: null as any, default: null },
  },
  setup(props) {
    return () => (
      <label class="flex h-full w-full items-center justify-center" style="pointer-events:none">
        <input
          type="checkbox"
          class="toggle toggle-primary toggle-xs"
          checked={Boolean(props.value)}
          onChange={() => {}}
        />
      </label>
    );
  },
});
